export const site = {
  name: 'Zuri Hub - AI Professional CX Tool for Every Business',
  tagline: 'AI-first customer experience platform for modern teams',
  baseUrl: 'https://getzurihub.com',
  workspaceUrl: 'https://portal.getzurihub.com',
  adminUrl: 'https://admin.getzurihub.com',
  apiUrl: 'https://zurichat-api.sales-f51.workers.dev',
  description:
    'Zuri Hub is an AI-first customer service platform that unifies live chat, tickets, knowledge base, omnichannel messaging, AI voice, and analytics in one place. Connect WhatsApp, Instagram, Telegram, Slack, and more.',
  twitter: 'https://x.com/zurihubQ',
  linkedin: 'https://www.linkedin.com/company/zurihubhq/?viewAsMember=true',
  youtube: 'https://www.youtube.com/@bahatiasher_faith?sub_confirmation=1',
  github: 'https://github.com/appnomu/Zurichat',
  ogImage: '/og-image.png',
  supportEmail: 'support@getzurihub.com',
  marketingEmail: 'marketing@getzurihub.com',
};

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Product', path: '/product' },
  { label: 'Features', path: '/features' },
  { label: 'Integrations', path: '/integrations' },
  { label: 'Pricing', path: '/pricing' },
  {
    label: 'Solutions',
    path: '/solutions',
    children: [
      { label: 'Industries', items: [
        { label: 'E-commerce', path: '/industry/ecommerce' },
        { label: 'Services', path: '/industry/services' },
        { label: 'Education', path: '/industry/education' },
        { label: 'Health', path: '/industry/health' },
        { label: 'Finance', path: '/industry/finance' },
        { label: 'SaaS', path: '/industry/saas' },
        { label: 'Travel', path: '/industry/travel' },
      ]},
      { label: 'Teams', items: [
        { label: 'Customer Service', path: '/solutions/customer-service' },
        { label: 'Marketing & Sales', path: '/solutions/marketing-and-sales' },
      ]},
    ],
  },
  { label: 'Careers', path: '/careers' },
  { label: 'Refer & Earn', path: '/referral' },
  { label: 'Book a Demo', path: '/book-a-demo' },
];

export const footerLinks = {
  company: [
    { label: 'About Zuri Hub', path: '/about' },
    { label: 'Startup Program', path: '/startup' },
    { label: 'Inclusion & Belonging', path: '/inclusion' },
    { label: 'Why Zuri', path: '/why-zuri' },
    { label: 'Careers', path: '/careers' },
    { label: 'News', path: '/news' },
    { label: 'Events', path: '/events' },
    { label: 'Conferences', path: '/conferences' },
    { label: 'Case Studies', path: '/case-studies' },
    { label: 'Write for Us', path: '/write-for-us' },
    { label: 'Contact', path: '/book-a-demo' },
  ],
  product: [
    { label: 'Product', path: '/product' },
    { label: 'Features', path: '/features' },
    { label: 'Pricing', path: '/pricing' },
    { label: 'Integrations', path: '/integrations' },
    { label: 'Live Chat', path: '/live-chat' },
    { label: 'Tickets', path: '/tickets' },
    { label: 'Knowledgebase', path: '/knowledgebase' },
    { label: 'Zyra AI', path: '/zyra-ai' },
    { label: 'Zyra Agent', path: '/zyra-agent' },
    { label: 'Zuri Voice', path: '/zuri-voice' },
    { label: 'Zuri Cloud', path: '/zuri-cloud' },
    { label: 'CSAT & Feedback', path: '/csat-feedback' },
  ],
  features: [
    { label: 'Moments', path: '/moments' },
    { label: 'Bulk Messaging', path: '/bulk-messaging' },
    { label: 'Email Marketing', path: '/email-marketing' },
    { label: 'Push Notifications', path: '/push-notifications' },
    { label: 'Content Lab', path: '/content-lab' },
    { label: 'Social Media Management', path: '/social-media-management' },
    { label: 'Analytics', path: '/website-analytics' },
    { label: 'Reporting & Analytics', path: '/reporting-and-analytics' },
    { label: 'Heatmaps', path: '/heatmaps' },
    { label: 'Screen Recording', path: '/screen-recording' },
    { label: 'Workflows & Automations', path: '/workflows-and-automations' },
    { label: 'Self Service', path: '/self-service' },
  ],
  tools: [
    { label: 'Proactive Service', path: '/proactive-service' },
    { label: 'Agent Service', path: '/agent-service' },
    { label: 'Text to Speech', path: '/text-to-speech' },
    { label: 'IVR Menus', path: '/ivr-menus' },
    { label: 'Number Masking', path: '/number-masking' },
    { label: 'White Label', path: '/white-label' },
    { label: 'Quality Assurance', path: '/quality-assurance' },
    { label: 'Workspace Portal', path: '/workspace-portal' },
    { label: 'ZuriHub for Government', path: '/zurihub-for-government' },
    { label: 'Road Map', path: '/road-map' },
    { label: 'WhatsApp Channel', path: '/channels/whatsapp' },
    { label: 'ZuriChat Channel', path: '/channels/zurichat' },
  ],
  industries: [
    { label: 'E-commerce', path: '/industry/ecommerce' },
    { label: 'Services', path: '/industry/services' },
    { label: 'Education', path: '/industry/education' },
    { label: 'Health', path: '/industry/health' },
    { label: 'Finance', path: '/industry/finance' },
    { label: 'SaaS', path: '/industry/saas' },
    { label: 'Travel', path: '/industry/travel' },
    { label: 'Customer Service', path: '/solutions/customer-service' },
    { label: 'Marketing & Sales', path: '/solutions/marketing-and-sales' },
    { label: 'ZuriHub for NGO', path: '/zurihub-for-ngo' },
    { label: 'ZuriHub for Education', path: '/zurihub-for-education' },
    { label: 'ZuriHub for Enterprise', path: '/zurihub-for-enterprise' },
    { label: 'ZuriHub for Small Business', path: '/zurihub-for-small-businesses' },
    { label: 'Help Centre', path: 'https://portal.getzurihub.com/kb?workspaceSlug=zurichat', external: true },
    { label: 'Compare', path: '/compare' },
    { label: 'Refer & Earn', path: '/referral' },
  ],
};

export const products = [
  {
    id: 'zyra-ai',
    name: 'Zyra AI',
    tagline: 'AI answers, summaries, and coaching',
    description:
      'Zyra suggests replies, summarizes chats, detects intent, and trains agents in real time. Every support rep becomes a top performer.',
    benefits: [
      'AI reply suggestions from your docs',
      'Instant conversation summaries',
      'Sentiment and intent detection',
      'Real-time agent coaching',
    ],
    cta: 'Explore Zyra AI',
  },
  {
    id: 'zuri-cloud',
    name: 'Zuri Cloud',
    tagline: 'Secure, global infrastructure',
    description:
      'The backbone that hosts every conversation, file, and metric. Built for scale, GDPR-ready, and backed by a 99.99% uptime SLA.',
    benefits: [
      '99.99% uptime SLA',
      'Global edge delivery',
      'SOC 2 and GDPR ready',
      'Auto-scales as you grow',
    ],
    cta: 'Explore Zuri Cloud',
  },
  {
    id: 'zuri-voice',
    name: 'Zuri Voice',
    tagline: 'AI voice calls inside the inbox',
    description:
      'Make, receive, transcribe, and route AI voice calls from the same workspace. No separate phone tool needed.',
    benefits: [
      'Inbound and outbound calls',
      'Real-time transcription',
      'Ticket and CRM context sync',
      'Call recording and QA insights',
    ],
    cta: 'Explore Zuri Voice',
  },
];

export const features = [
  {
    title: 'Unified Inbox',
    description: 'One stream for every channel. Email, chat, WhatsApp, Telegram, and social in one view.',
    icon: 'Inbox',
  },
  {
    title: 'Live Chat',
    description: 'Embed a fast chat widget and convert visitors while they are still on your site.',
    icon: 'MessageSquare',
  },
  {
    title: 'Ticket Management',
    description: 'Assign, tag, prioritize, and automate tickets so nothing falls through the cracks.',
    icon: 'Ticket',
  },
  {
    title: 'Knowledge Base',
    description: 'Publish public help centers and private wikis that customers and agents can search.',
    icon: 'BookOpen',
  },
  {
    title: 'AI Assistant',
    description: 'Zyra drafts replies, summarizes threads, and flags urgent conversations instantly.',
    icon: 'Sparkles',
  },
  {
    title: 'AI Voice',
    description: 'Handle and transcribe voice calls without leaving Zuri Hub.',
    icon: 'Phone',
  },
  {
    title: 'Canned Responses',
    description: 'Insert pre-written replies in one click to cut first-response time.',
    icon: 'MessageCircle',
  },
  {
    title: 'Live Typing',
    description: 'See what the customer is typing before they hit send and reply faster.',
    icon: 'Pencil',
  },
  {
    title: 'Analytics',
    description: 'Track resolution times, CSAT, channel mix, and team performance in real time.',
    icon: 'BarChart3',
  },
  {
    title: 'Team Notes',
    description: 'Add private notes to any conversation without cluttering the customer thread.',
    icon: 'StickyNote',
  },
];

export const workspaceFeatures = [
  {
    category: 'Conversations',
    summary: 'Talk to customers on every channel from one workspace.',
    features: [
      {
        title: 'Conversations',
        description: 'A unified inbox that brings live chat, email, and social messages into one thread.',
        icon: 'MessageSquare',
      },
      {
        title: 'Channels',
        description: 'Connect WhatsApp, Instagram, Telegram, X, Messenger, Gmail, and live chat instantly.',
        icon: 'Hash',
      },
      {
        title: 'Canned Responses',
        description: 'Insert saved replies with one click to cut first-response time.',
        icon: 'MessageCircle',
      },
      {
        title: 'Live Typing',
        description: 'See what customers are typing before they hit send and answer faster.',
        icon: 'Pencil',
      },
    ],
  },
  {
    category: 'Customer Success',
    summary: 'Convert, support, and retain customers at every stage.',
    features: [
      {
        title: 'Tickets',
        description: 'Create, assign, tag, and resolve customer issues with custom workflows.',
        icon: 'Ticket',
      },
      {
        title: 'Knowledge Base',
        description: 'Publish public help centers and internal wikis that agents can search in one click.',
        icon: 'BookOpen',
      },
      {
        title: 'Leads',
        description: 'Capture prospects, score them, and hand them off to sales or support.',
        icon: 'Target',
      },
      {
        title: 'Refer & Earn',
        description: 'Grow through a built-in referral program and track every invite.',
        icon: 'Gift',
      },
    ],
  },
  {
    category: 'AI & Automation',
    summary: 'Let Zyra handle the routine so your team can focus on what matters.',
    features: [
      {
        title: 'AI Configure',
        description: 'Set up Zyra AI with your knowledge base, tone, and escalation rules.',
        icon: 'Sparkles',
      },
      {
        title: 'AI Training',
        description: 'Fine-tune Zyra on past conversations to improve reply quality over time.',
        icon: 'Sparkles',
      },
      {
        title: 'AI Voice Call',
        description: 'Make, receive, and transcribe AI voice calls without leaving the inbox.',
        icon: 'Phone',
      },
    ],
  },
  {
    category: 'Team & Docs',
    summary: 'Keep your team aligned and your documentation close.',
    features: [
      {
        title: 'Team',
        description: 'Manage members, roles, and availability across shifts.',
        icon: 'Users',
      },
      {
        title: 'Docx',
        description: 'Create, share, and edit internal documents and SOPs.',
        icon: 'FileText',
      },
      {
        title: 'Team Notes',
        description: 'Leave private notes on any conversation without cluttering the customer thread.',
        icon: 'StickyNote',
      },
    ],
  },
  {
    category: 'Operations',
    summary: 'Run the business side of customer experience with confidence.',
    features: [
      {
        title: 'Invoices',
        description: 'Generate and track invoices for services, products, or subscriptions.',
        icon: 'Receipt',
      },
      {
        title: 'Billing & Plan',
        description: 'Manage seats, payment methods, and usage in one place.',
        icon: 'CreditCard',
      },
      {
        title: 'My Account',
        description: 'Update profile, security, and workspace preferences.',
        icon: 'User',
      },
      {
        title: 'Settings',
        description: 'Configure workflows, permissions, integrations, and brand settings.',
        icon: 'Settings',
      },
    ],
  },
  {
    category: 'Analytics',
    summary: 'Measure what matters and improve every day.',
    features: [
      {
        title: 'Analytics',
        description: 'Track resolution times, CSAT, channel mix, and team performance in real time.',
        icon: 'BarChart3',
      },
    ],
  },
];

export const useCases = [
  {
    title: 'Customer Support',
    icon: 'MessageCircle',
    description:
      'Resolve tickets, answer live chat, and deflect FAQs with AI — all from one inbox.',
  },
  {
    title: 'Sales & Pre-Sales',
    icon: 'Target',
    description:
      'Capture leads on WhatsApp and Instagram, qualify them, and hand them off to sales.',
  },
  {
    title: 'Technical Operations',
    icon: 'Zap',
    description:
      'Track incidents, manage docs, and align engineering, support, and product teams.',
  },
  {
    title: 'Billing & Accounts',
    icon: 'CreditCard',
    description:
      'Handle invoices, plan questions, and payment issues without bouncing customers between tools.',
  },
];

export const serviceQuality = [
  {
    metric: '99.99%',
    label: 'Uptime SLA',
    description: 'Built on Zuri Cloud with global edge delivery.',
  },
  {
    metric: '<200ms',
    label: 'Median API response',
    description: 'Fast APIs keep your agents and customers moving.',
  },
  {
    metric: 'SOC 2 / GDPR',
    label: 'Compliance ready',
    description: 'Encryption, access controls, and privacy by design.',
  },
  {
    metric: '24/7',
    label: 'Support on Enterprise',
    description: 'Priority support for Pro and dedicated help for Enterprise.',
  },
];

export const scalability = {
  title: 'Built to scale with your business',
  subtitle: 'From your first agent to your thousandth.',
  tiers: [
    {
      agents: '1',
      plan: 'Free',
      capabilities:
        'Core chat, tickets, and knowledge base for one agent.',
    },
    {
      agents: '5-100',
      plan: 'Pro',
      capabilities:
        'Unlimited agents, all channels, AI replies, canned responses, and analytics.',
    },
    {
      agents: '100+',
      plan: 'Enterprise',
      capabilities:
        'Custom SLAs, SSO, AI voice, private cloud, and 24/7 support.',
    },
  ],
};

export const featureHighlights = [
  {
    id: 'security',
    title: 'Enterprise-ready security',
    icon: 'Shield',
    summary:
      'Keep customer data safe with encryption, access controls, and compliance built in from day one.',
    items: [
      'GDPR-ready data handling',
      'SOC 2 Type II in progress',
      'End-to-end encryption at rest and in transit',
      'SSO and role-based permissions on Enterprise',
    ],
  },
  {
    id: 'brand',
    title: 'Designed for your brand',
    icon: 'Palette',
    summary:
      'Make every customer touchpoint feel like your own product, not a third-party tool.',
    items: [
      'Custom domain for your help center',
      'Branded live chat widget',
      'White-label workspace experience',
      'Custom CSS and brand colors',
    ],
  },
];

export const integrations = [
  { name: 'WhatsApp', icon: 'MessageCircle', color: 'bg-green-500' },
  { name: 'Instagram', icon: 'Instagram', color: 'bg-pink-500' },
  { name: 'Telegram', icon: 'Send', color: 'bg-sky-500' },
  { name: 'X', icon: 'X', color: 'bg-slate-900' },
  { name: 'Messenger', icon: 'MessageCircle', color: 'bg-blue-500' },
  { name: 'ZuriChat', icon: 'MessageSquare', color: 'bg-brand-600' },
  { name: 'Google Analytics', icon: 'BarChart3', color: 'bg-orange-500' },
];

export const channels = [
  { name: 'WhatsApp', brand: 'WhatsApp', color: '#25D366' },
  { name: 'Instagram', brand: 'Instagram', color: '#E1306C' },
  { name: 'Telegram', brand: 'Telegram', color: '#0088cc' },
  { name: 'X', brand: 'X', color: '#000000' },
  { name: 'Messenger', brand: 'Messenger', color: '#0084FF' },
  { name: 'ZuriChat', brand: 'ZuriChat', color: '#2563eb' },
  { name: 'Gmail', brand: 'Gmail', color: '#EA4335' },
  { name: 'Live Chat', brand: 'LiveChat', color: '#8b5cf6' },
  { name: 'Email', brand: 'Email', color: '#6366f1' },
];

export const industries = [
  {
    name: 'E-commerce',
    icon: 'ShoppingBag',
    stat: '40% faster replies',
    description: 'Handle order questions, refunds, and shipping across WhatsApp, Instagram, and live chat.',
  },
  {
    name: 'SaaS',
    icon: 'Cloud',
    stat: '30% lower churn',
    description: 'Turn trials into customers with proactive chat, tickets, and self-serve docs.',
  },
  {
    name: 'Healthcare',
    icon: 'HeartPulse',
    stat: 'HIPAA-ready tools',
    description: 'Schedule, answer patient questions, and keep teams aligned with secure messaging.',
  },
  {
    name: 'Fintech',
    icon: 'Landmark',
    stat: '99.99% uptime SLA',
    description: 'Support account holders across chat, email, and voice with full audit trails.',
  },
  {
    name: 'Education',
    icon: 'GraduationCap',
    stat: 'One help desk',
    description: 'Admissions, student support, and parent queries in a single shared inbox.',
  },
  {
    name: 'Logistics',
    icon: 'Truck',
    stat: 'Real-time tracking',
    description: 'Update drivers, customers, and partners from any channel without switching apps.',
  },
];

export const customerStats = [
  { value: '365+', label: 'teams use Zuri Hub' },
  { value: '45M+', label: 'conversations handled' },
  { value: '99.99%', label: 'average uptime' },
  { value: '20X', label: 'faster resolution' },
];

export const customerLogos = [
  'E-commerce brands in 12 countries',
  'Top 100 SaaS startups in Africa',
  'Health clinics across 3 continents',
  'Fintechs processing $2B+ monthly',
];

export const brandLogos = [
  { name: 'Pumzi Teas', logo: 'https://pumziteas.com/assets/images/pumzi_logo.jpg' },
  { name: 'AppNomu SalesQ', logo: 'https://appnomu.com/landing/assets/images/5_Years.jpeg' },
  { name: 'Brlogic', logo: 'https://d1024mmf9dgym2.cloudfront.net/site/assets/images/logo-white.svg?_t=5a2be9f86f', dark: true },
  { name: 'CodeLab', logo: 'https://codelab.appnomu.com/assets/images/CMODERN.png' },
  { name: 'Allianz', logo: 'https://www.allianzcare.com/content/dam/onemarketing/system/allianz-logo.svg' },
  { name: 'SheCare', logo: 'https://shecare.africa/shecare_logo.png' },
  { name: 'Fundrazr', logo: 'https://fundrazr.com/wp-content/uploads/2023/01/fundrazr-logo60px.png' },
  { name: 'UBA', logo: 'https://www.ubauganda.com/wp-content/uploads/sites/22/2018/06/UBA-Logo.svg' },
  { name: 'PesaPal', logo: 'https://www.pesapal.com/media/118158/pesapal-logo.png?v=3' },
  { name: 'Ascentify', logo: 'https://ascenify.tech/wp-content/uploads/2024/08/cropped-Ascenify-Logo-1.jpg' },
  { name: 'Blaze', logo: 'https://cdn.prod.website-files.com/64cd367074be316f3359db61/6928fa497ff98d7dd089edd6_footer-logo.svg', dark: true },
  { name: 'Brighter Monday', logo: 'https://v.fastcdn.co/u/c4f10d83/66024724-0-BrighterMonday-Ugand.svg' },
  { name: 'Hima Cement', logo: 'https://himacement.co.ug/wp-content/uploads/2026/02/LOGO.png' },
  { name: 'Kasese Sugar', logo: 'https://www.kasese.go.ug/wp-content/uploads/2020/01/Kasese-District-logo-1.png' },
  { name: 'Wenereco', logo: 'https://wenreco.co.ug/wp-content/uploads/2021/12/WENRECo_Logo-300x271.png' },
  { name: 'UpSend', logo: 'https://media.getzurihub.com/Jayrah%20Assets/UPSEND%20APP.png' },
  { name: 'Ibuth Safaris', logo: 'https://pbs.twimg.com/profile_images/1559922677657239552/0UDpLVDd_400x400.jpg' },
];

export const customerJourneyStages = [
  { id: 'awareness', title: 'Awareness', description: 'Discover a unified CX platform through search, social, referrals, and problem-focused landing pages.' },
  { id: 'consideration', title: 'Consideration', description: 'Compare features, pricing, and use cases with transparent comparisons, live demos, and customer stories.' },
  { id: 'decision', title: 'Decision', description: 'Start a free workspace, invite agents, and validate the product in minutes — no credit card needed.' },
  { id: 'retention', title: 'Retention', description: 'Get value fast with onboarding, knowledge base, and support resources designed to keep your team productive.' },
  { id: 'advocacy', title: 'Advocacy', description: 'Earn credits and commissions by referring others and sharing success stories with the community.' },
];

export const pricingPlans = [
  {
    name: 'Free',
    priceUSD: 0,
    period: 'forever',
    description: 'For small teams trying Zuri Hub.',
    features: [
      '1 agent',
      '100 tickets / month',
      'Live chat widget',
      'Basic knowledge base',
      '7-day support history',
      'Community support',
    ],
    cta: 'Start Free',
    href: site.workspaceUrl,
    featured: false,
  },
  {
    name: 'Pro',
    priceUSD: 25,
    period: 'per agent / month',
    description: 'For growing teams that need omnichannel CX.',
    features: [
      'Unlimited agents',
      'Unlimited tickets',
      'All channels: WhatsApp, Instagram, Telegram, Messenger, TikTok, LinkedIn',
      'Knowledge base with custom domain',
      'AI reply suggestions (Zyra AI)',
      'Canned responses & live typing',
      '24/5 support (Chat, Email, Ticket)',
      'Ticket templates access',
      '2FA Access (Email & Authenticator)',
      'Advanced Analytics',
      'Leads & Leads analytics',
      'Role Management (Owner, Admin, Agent)',
      'Department',
      'Voice Call (pay-as-you-go addon)',
      'Live chat widget & In-app call',
    ],
    cta: 'Start Pro Trial',
    href: site.workspaceUrl,
    featured: true,
  },
  {
    name: 'Enterprise',
    priceUSD: 390,
    period: 'for 10 agents / month',
    description: 'For organizations with advanced security and scale needs.',
    features: [
      'Everything in Pro',
      'XCHAT integration',
      'LinkedIn Message integration',
      'Social Media Management (Facebook, LinkedIn, Instagram, X, YouTube)',
      'Content Lab for Enterprise',
      'Custom Roles',
      'Advanced analytics reports',
      '24/7 support (Phone, Email, Live chat)',
      'Free Voice Call number (US number, no monthly fee)',
      'Access to Advanced AI powered by Zyra Agent',
      'Departments',
      'Custom SLAs & uptime',
      'Dedicated success manager',
      'SSO and advanced roles',
      'On-premise or private cloud options',
    ],
    cta: 'Book Demo',
    href: '/book-a-demo',
    featured: false,
  },
];

export const calculator = {
  title: 'How much can you save with Zuri Hub?',
  subtitle: 'Compare Zuri Hub at $25/agent to the tools you already pay for.',
  zuriPrice: 25,
  competitors: [
    { name: 'Intercom', price: 99, color: 'bg-slate-900' },
    { name: 'Zendesk', price: 99, color: 'bg-emerald-600' },
    { name: 'Front', price: 59, color: 'bg-indigo-500' },
    { name: 'Gorgias', price: 60, color: 'bg-rose-500' },
  ],
};

export const customerJourney = [
  {
    step: '1',
    title: 'Start free',
    description: 'Sign up for the Free plan. One agent, one workspace, full access to the core inbox and knowledge base.',
  },
  {
    step: '2',
    title: 'Connect channels',
    description: 'Add WhatsApp, Telegram, Messenger, email, live chat, and X in minutes. Bring your team and customers into one place.',
  },
  {
    step: '3',
    title: 'Scale with Pro',
    description: 'Unlock unlimited agents, AI reply suggestions, canned responses, and a custom-domain knowledge base as your volume grows.',
  },
  {
    step: '4',
    title: 'Customize & grow',
    description: 'Pick the add-ons you need — premium KB themes, voice numbers, analytics, and white-label — and upgrade to Enterprise for SSO and SLAs.',
  },
];

export const pricingAddons = [
  {
    name: 'Voice Number',
    icon: 'Phone',
    description: 'A dedicated phone number for inbound and outbound voice calls. Available in Uganda, Kenya, Nigeria, Ethiopia, South Africa, Tanzania, Rwanda, and USA. Setup fee applies. USA numbers have no monthly fee.',
    priceUSD: 25,
    period: '/mo',
    cta: 'Add a number',
    href: 'https://portal.getzurihub.com',
  },
  {
    name: 'Call Recording',
    icon: 'Shield',
    description: 'Record, store, and review calls for quality assurance and compliance. Pay only for the minutes you record.',
    priceUSD: 0.005,
    period: '/minute',
    cta: 'Enable recording',
    href: 'https://portal.getzurihub.com',
  },
  {
    name: 'Call Transcription',
    icon: 'Mic',
    description: 'AI-powered real-time speech-to-text transcription. Every call is transcribed live so agents can search and review later.',
    priceUSD: 0.004,
    period: '/minute',
    cta: 'Enable transcription',
    href: 'https://portal.getzurihub.com',
  },
  {
    name: 'Premium KB Themes',
    icon: 'Palette',
    description: 'Unlock Ocean, Midnight, Berry and Royal themes for your public knowledge base. One-time purchase for the workspace.',
    priceUSD: 190,
    period: 'one-time',
    cta: 'Get themes',
    href: 'https://portal.getzurihub.com',
  },
  {
    name: 'Custom CSS',
    icon: 'Code',
    description: 'Bring your own brand to the knowledge base with full custom CSS control. Included with Premium Themes.',
    priceUSD: 0,
    period: '',
    cta: 'Use custom CSS',
    href: 'https://portal.getzurihub.com',
  },
  {
    name: 'Heatmaps',
    icon: 'Flame',
    description: 'Session replay, click and scroll tracking, and page snapshots so you see how visitors actually use your site.',
    priceUSD: 15,
    period: '/mo',
    cta: 'Enable Heatmaps',
    href: 'https://portal.getzurihub.com',
  },
  {
    name: 'Push Notifications',
    icon: 'Share2',
    description: 'Engage customers in real-time with browser and mobile push notifications. Send scheduled campaigns, rich media attachments, and segmented messages across Chrome, Firefox, Safari, Android, and iOS. Unlimited sends.',
    priceUSD: 12,
    period: '/mo',
    cta: 'Add Push Notifications',
    href: 'https://portal.getzurihub.com',
  },
  {
    name: 'Live Visitors',
    icon: 'Users',
    description: 'Real-time visitor counters, top pages, devices, and geo. Get a live feed of who is browsing your site.',
    priceUSD: 0,
    period: '',
    cta: 'Talk to us',
    href: 'https://portal.getzurihub.com',
    contactSales: true,
  },
  {
    name: 'White Label',
    icon: 'Layers',
    description: 'Rebrand the business workspace, portal, and customer-facing widgets with your own logo, colors, and domain.',
    priceUSD: 0,
    period: '',
    cta: 'Book Demo',
    href: '/book-a-demo',
    enterprise: true,
  },
];

export const migration = {
  title: 'Migrate from any support stack',
  subtitle: 'We make it easy to move your team, tickets, and contacts into Zuri Hub.',
  from: ['Intercom', 'Zendesk', 'Front', 'Freshdesk', 'Gorgias', 'Help Scout'],
  benefits: [
    'Free migration support on Pro and Enterprise',
    'Keep conversation history and tags',
    'Import users, contacts, and knowledge base',
    'Get set up in days, not months',
  ],
};

export const comparison = {
  title: 'Why teams choose Zuri Hub',
  rows: [
    { feature: 'Unified inbox (chat, email, social)', zurihub: true, intercom: false, zendesk: 'partial' },
    { feature: 'AI reply suggestions', zurihub: true, intercom: true, zendesk: 'partial' },
    { feature: 'Built-in voice calls with transcription', zurihub: true, intercom: false, zendesk: false },
    { feature: 'TikTok & LinkedIn integration', zurihub: true, intercom: false, zendesk: false },
    { feature: 'Ticket templates', zurihub: true, intercom: false, zendesk: true },
    { feature: '2FA (Email & Authenticator)', zurihub: true, intercom: true, zendesk: true },
    { feature: 'Role Management (Owner, Admin, Agent)', zurihub: true, intercom: true, zendesk: true },
    { feature: 'Departments', zurihub: true, intercom: true, zendesk: true },
    { feature: 'Leads & Leads analytics', zurihub: true, intercom: false, zendesk: 'partial' },
    { feature: 'Free plan for 1 agent', zurihub: true, intercom: false, zendesk: false },
    { feature: 'Starting price per agent', zurihub: '$25', intercom: '$99', zendesk: '$99' },
    { feature: 'Enterprise for 10 agents', zurihub: '$390/mo', intercom: 'Custom', zendesk: 'Custom' },
    { feature: 'GDPR & SOC 2 ready', zurihub: true, intercom: true, zendesk: true },
    { feature: 'Native WhatsApp & Telegram', zurihub: true, intercom: 'partial', zendesk: 'add-on' },
    { feature: 'Open API & webhooks', zurihub: true, intercom: true, zendesk: true },
  ],
};

export const faqs = [
  {
    question: 'What can I do with Zuri Hub?',
    answer:
      'Run your entire customer experience from one workspace: live chat, tickets, knowledge base, omnichannel messaging, AI voice calls, analytics, billing, and more.',
  },
  {
    question: 'Which channels are supported?',
    answer:
      'WhatsApp, Instagram, Telegram, Messenger, TikTok, LinkedIn, email, Gmail, live chat, and our own ZuriChat channel.',
  },
  {
    question: 'How does Zyra AI help my team?',
    answer:
      'Zyra drafts replies, summarizes long threads, detects customer sentiment, and escalates urgent issues to the right person.',
  },
  {
    question: 'What is included in the Pro plan?',
    answer:
      'Pro includes unlimited agents, unlimited tickets, all channels (WhatsApp, Instagram, Telegram, Messenger, TikTok, LinkedIn), knowledge base with custom domain, AI reply suggestions, canned responses, 24/5 support (Chat, Email, Ticket), ticket templates, 2FA, advanced analytics, leads & leads analytics, role management, departments, and voice call (pay-as-you-go addon).',
  },
  {
    question: 'What is included in the Enterprise plan?',
    answer:
      'Enterprise is $390/month for 10 agents and includes everything in Pro plus XCHAT integration, LinkedIn Message integration, Social Media Management (Facebook, LinkedIn, Instagram, X, YouTube, TikTok), Content Lab for Enterprise, custom roles, advanced analytics reports, 24/7 support (Phone, Email, Live chat), free Voice Call number (US number with no monthly fee), access to Advanced AI powered by Zyra Agent, departments, custom SLAs, dedicated success manager, SSO, and on-premise or private cloud options.',
  },
  {
    question: 'What is Content Lab?',
    answer:
      'Content Lab is an Enterprise content creation and management platform that helps teams generate, collaborate on, and publish content across Facebook, LinkedIn, Instagram, X, YouTube, and TikTok with AI-powered tools and real-time team collaboration.',
  },
  {
    question: 'What is Social Media Management?',
    answer:
      'Social Media Management is an Enterprise feature that lets you manage Facebook, LinkedIn, Instagram, X, YouTube, and TikTok from one unified inbox with a single inbox, scheduling tools, team collaboration, and analytics.',
  },
  {
    question: 'How does voice call pricing work?',
    answer:
      'Voice calls are pay-as-you-go. Voice calls start at $0.008/min (receive) and $0.01/min (make). Live chat widget and in-app calls are $0.005/min (receive) and $0.007/min (make). Phone numbers cost $25 setup with $25/month fee in most countries, but US numbers have no monthly fee. Call recording is $0.005/min and transcription is $0.004/min.',
  },
  {
    question: 'Can I migrate from Zendesk or Intercom?',
    answer:
      'Yes. We offer free migration support on Pro and Enterprise plans. You keep conversation history, contacts, tags, and your knowledge base.',
  },
  {
    question: 'Is there a free plan?',
    answer:
      'Yes. The Free plan covers one agent, 100 tickets per month, live chat, a basic knowledge base, and community support.',
  },
  {
    question: 'What industries use Zuri Hub?',
    answer:
      'E-commerce, SaaS, healthcare, fintech, education, and logistics teams use Zuri Hub to unify customer conversations and cut costs.',
  },
  {
    question: 'How do I book a demo for Enterprise?',
    answer:
      'Use the Book a Demo page and select Enterprise. Our team will reply within one business day to schedule a personalized demo of Enterprise features including Zyra Agent, Content Lab, and Social Media Management.',
  },
];

export const solutionIndustries = [
  {
    slug: 'ecommerce',
    name: 'E-commerce',
    icon: 'ShoppingBag',
    metaTitle: 'E-commerce Customer Support Software | Zuri Hub',
    metaDescription:
      'Manage orders, returns, and shopper conversations across WhatsApp, Instagram, live chat, and email from one workspace.',
    headline: 'Turn every shopper into a repeat buyer',
    summary:
      'From checkout questions to delivery updates, Zuri Hub unifies every customer touchpoint so your team can sell more and support faster.',
    painPoints: [
      { title: 'Cart abandonment', text: 'Answer WhatsApp and live-chat questions while shoppers are still browsing.' },
      { title: 'Refund delays', text: 'Track order issues, assign tickets, and update customers in one thread.' },
      { title: 'Channel chaos', text: 'Email, social, and chat messages land in the same inbox.' },
    ],
    benefits: [
      'Unified inbox for all shopper channels',
      'AI replies trained on your product catalog',
      'Order and invoice tracking inside tickets',
      'Shared team notes on every conversation',
    ],
    cta: 'See Zuri Hub for e-commerce',
  },
  {
    slug: 'services',
    name: 'Services',
    icon: 'Briefcase',
    metaTitle: 'Customer Service Software for Service Businesses | Zuri Hub',
    metaDescription:
      'Manage client requests, appointments, and project updates across chat, email, and tickets for service companies.',
    headline: 'Deliver a client experience that wins referrals',
    summary:
      'Professional services teams use Zuri Hub to keep client conversations, quotes, appointments, and follow-ups in one place.',
    painPoints: [
      { title: 'Missed leads', text: 'Capture WhatsApp and Instagram leads before they go cold.' },
      { title: 'Slow quotes', text: 'Share estimates and answer questions in the same thread.' },
      { title: 'No history', text: 'Every client interaction is logged and searchable.' },
    ],
    benefits: [
      'One inbox for every client channel',
      'Appointment and quote tracking',
      'AI drafts for fast follow-ups',
      'Team notes on every client thread',
    ],
    cta: 'See Zuri Hub for services',
  },
  {
    slug: 'education',
    name: 'Education',
    icon: 'GraduationCap',
    metaTitle: 'Education Help Desk Software | Zuri Hub',
    metaDescription:
      'Admissions, student support, and parent queries handled in a single shared inbox with AI and knowledge base tools.',
    headline: 'Support students, parents, and staff in one place',
    summary:
      'Schools, universities, and edtech teams use Zuri Hub to handle admissions, IT help, and parent questions across every channel.',
    painPoints: [
      { title: 'Siloed departments', text: 'Admissions, IT, and finance use one shared inbox.' },
      { title: 'Repeated questions', text: 'Deflect FAQs with a public knowledge base and AI replies.' },
      { title: 'Slow responses', text: 'Route urgent student issues to the right team instantly.' },
    ],
    benefits: [
      'Shared inbox for every department',
      'Public help centers for students and parents',
      'AI replies for common questions',
      'Custom routing by topic or urgency',
    ],
    cta: 'See Zuri Hub for education',
  },
  {
    slug: 'health',
    name: 'Health',
    icon: 'HeartPulse',
    metaTitle: 'HIPAA-Ready Healthcare Support | Zuri Hub',
    metaDescription:
      'Schedule appointments, answer patient questions, and keep care teams aligned with secure, compliant messaging.',
    headline: 'Patient-first communication at scale',
    summary:
      'Clinics, telehealth, and health tech teams use Zuri Hub to coordinate appointments, patient queries, and follow-ups securely.',
    painPoints: [
      { title: 'Privacy risk', text: 'Control access with role-based permissions and encrypted channels.' },
      { title: 'Missed appointments', text: 'Send reminders and schedule updates via WhatsApp or SMS.' },
      { title: 'Slow triage', text: 'Route patient messages to the right caregiver instantly.' },
    ],
    benefits: [
      'Secure, role-based messaging',
      'Appointment and reminder workflows',
      'HIPAA-ready privacy controls',
      'Care team notes and handoffs',
    ],
    cta: 'See Zuri Hub for health',
  },
  {
    slug: 'finance',
    name: 'Finance',
    icon: 'Landmark',
    metaTitle: 'Fintech Customer Support | Zuri Hub',
    metaDescription:
      'Support account holders across chat, email, and voice with full audit trails and 99.99% uptime.',
    headline: 'Trusted support for regulated finance',
    summary:
      'Banks, fintechs, and payment providers use Zuri Hub to resolve account questions, disputes, and payment issues with full audit trails.',
    painPoints: [
      { title: 'Compliance pressure', text: 'Every conversation is logged and searchable for audit.' },
      { title: 'Fraud alerts', text: 'Route urgent security issues to the right team in seconds.' },
      { title: 'Channel overload', text: 'One inbox for in-app chat, email, and WhatsApp.' },
    ],
    benefits: [
      'Full conversation audit trail',
      'Role-based access for agents and admins',
      'AI voice and secure messaging',
      '99.99% uptime SLA on Enterprise',
    ],
    cta: 'See Zuri Hub for finance',
  },
  {
    slug: 'saas',
    name: 'SaaS',
    icon: 'Cloud',
    metaTitle: 'SaaS Customer Support & Sales | Zuri Hub',
    metaDescription:
      'Turn trials into customers with proactive chat, tickets, and self-serve docs for SaaS teams.',
    headline: 'Convert and retain more SaaS customers',
    summary:
      'SaaS teams use Zuri Hub to support trials, onboard users, and reduce churn with live chat, tickets, AI, and a knowledge base.',
    painPoints: [
      { title: 'Trial drop-off', text: 'Reach out via live chat and WhatsApp while users are evaluating.' },
      { title: 'Feature confusion', text: 'Answer product questions with AI and in-app help.' },
      { title: 'Support bottlenecks', text: 'Scale from one agent to hundreds without changing tools.' },
    ],
    benefits: [
      'Proactive chat for trials and onboarding',
      'Product knowledge base for self-serve',
      'AI reply suggestions for agents',
      'Scalable per-agent pricing',
    ],
    cta: 'See Zuri Hub for SaaS',
  },
  {
    slug: 'travel',
    name: 'Travel',
    icon: 'Plane',
    metaTitle: 'Travel & Hospitality Customer Support | Zuri Hub',
    metaDescription:
      'Handle bookings, changes, and traveler questions across WhatsApp, email, live chat, and social in one workspace.',
    headline: 'Traveler support that never misses a beat',
    summary:
      'Travel agencies, hotels, and booking platforms use Zuri Hub to manage reservations, cancellations, and guest questions in real time.',
    painPoints: [
      { title: 'Time-sensitive changes', text: 'Answer WhatsApp and live chat while travelers are on the move.' },
      { title: 'Booking confusion', text: 'Pull booking context into every ticket and reply.' },
      { title: 'Guest reviews', text: 'Resolve issues quickly to earn better ratings.' },
    ],
    benefits: [
      'Real-time chat for urgent bookings',
      'Shared inbox for WhatsApp, email, and social',
      'Booking and itinerary context in tickets',
      'AI replies for common travel questions',
    ],
    cta: 'See Zuri Hub for travel',
  },
];

export const solutionTeams = [
  {
    slug: 'customer-service',
    name: 'Customer Service',
    icon: 'Headset',
    metaTitle: 'Customer Service Software by Zuri Hub',
    metaDescription:
      'Resolve tickets, live chat, and social messages from one workspace with AI coaching and omnichannel tools.',
    headline: 'Support that keeps customers coming back',
    summary:
      'Zuri Hub gives customer service teams a single workspace for tickets, live chat, WhatsApp, email, AI replies, and self-serve knowledge bases.',
    painPoints: [
      { title: 'Siloed channels', text: 'Email, chat, and social messages live in one inbox.' },
      { title: 'Slow responses', text: 'AI suggests replies and automates common questions.' },
      { title: 'No context', text: 'Customer history, orders, and tickets are visible in every thread.' },
    ],
    benefits: [
      'Unified inbox across all channels',
      'AI reply suggestions and summaries',
      'Knowledge base deflection',
      'Ticket routing, SLAs, and team notes',
    ],
    cta: 'See customer service tools',
  },
  {
    slug: 'marketing-and-sales',
    name: 'Marketing & Sales',
    icon: 'TrendingUp',
    metaTitle: 'Marketing & Sales Messaging by Zuri Hub',
    metaDescription:
      'Capture leads on WhatsApp, Instagram, and live chat, then hand them off faster with Zuri Hub.',
    headline: 'Convert conversations into revenue',
    summary:
      'Marketing and sales teams use Zuri Hub to capture, qualify, and route leads from WhatsApp, Instagram, live chat, and email.',
    painPoints: [
      { title: 'Lost leads', text: 'Capture inbound DMs and chat before competitors do.' },
      { title: 'Slow handoffs', text: 'Qualify and assign leads to sales in one click.' },
      { title: 'No tracking', text: 'See every lead, campaign, and touchpoint in one place.' },
    ],
    benefits: [
      'Lead capture from every channel',
      'Qualification workflows and tags',
      'CRM-style lead notes and history',
      'Shared inbox with support for context',
    ],
    cta: 'See marketing & sales tools',
  },
];

export const legal = {
  terms: {
    title: 'Terms of Use',
    lastUpdated: '25th September 2026',
    sections: [
      {
        title: '1. Introduction',
        paragraphs: [
          'These Terms of Use govern your access to and use of the ZuriHub website, applications, and services operated by Zurichat Technology Company Limited. By creating an account, accessing the platform, or using any part of the service, you agree to be bound by these Terms and our Privacy Policy.',
          'If you are using ZuriHub on behalf of an organization, you represent that you have authority to bind that organization to these Terms. If you do not agree, please do not use the Service.',
        ],
      },
      {
        title: '2. Definitions',
        paragraphs: [
          'ZuriHub, we, us, and our refer to Zurichat Technology Company Limited.',
          'Service means the ZuriHub software, website, and related support.',
          'You means the individual or entity using the Service.',
          'Customer Data means all data, messages, contacts, tickets, invoices, call recordings, and content you or your team submit through the Service.',
          'Workspace means a business account created on ZuriHub where Customer Data is stored and managed.',
          'AI Voice means the AI-assisted voice call feature that can make, receive, transcribe, and route calls inside the ZuriHub inbox through an integrated CPaaS platform. AI Voice includes both traditional phone number calling and live chat widget/in-app calling without phone numbers.',
          'Voice Number means a dedicated phone number rented by a workspace for traditional inbound and outbound calls. Numbers are available in multiple countries with different pricing structures.',
          'Voice Wallet means a prepaid balance used to pay for per-minute voice call charges, recording, transcription, and other voice-related services.',
          'IVR means Interactive Voice Response, a system that allows callers to interact with a computer-operated system through voice or keypad input to route calls or provide information.',
          'Number Masking means a privacy feature that anonymizes phone numbers in voice calls to protect personal contact information.',
          'Heatmaps and Live Analytics means the optional visitor tracking and behavior analytics add-on that collects page views, clicks, scrolls, and session recordings on customer websites.',
          'Push Notifications means the feature that enables businesses to send real-time browser and mobile push notifications to customers and users for engagement, updates, and promotional campaigns. Push Notifications includes web push for browsers and native push for iOS and Android applications.',
          'Enterprise Plan means a ZuriHub subscription tier that includes advanced security, SSO, SCIM, custom SLAs, private cloud options, AI voice, dedicated support, and access to Zyra Agent.',
          'Zyra Agent means an Enterprise AI assistant that can autonomously handle conversations across channels, maintain natural-language context, and resolve tickets without per-token or per-resolution charges.',
          'White Label means the ability for Enterprise workspaces to rebrand the ZuriHub sidebar, portal, and customer-facing widgets with their own logo, colors, and domain.',
          'Dedicated Instance means a single-tenant or private-cloud deployment option available under Enterprise terms.',
          'GitHub OAuth means the optional single sign-on method that lets users authenticate using a GitHub account, in addition to email, Google, and LinkedIn.',
          'Knowledge Base means the workspace tool used to publish public and private help centers, articles, and self-serve documentation.',
          'KB Themes means the visual presets and custom CSS available to brand a public knowledge base, including free and premium theme options.',
          'Startup Program means the ZuriHub offering that provides eligible startups with workspace credit, onboarding, and discounted access.',
          'ZuriHub for Government means the tailored deployment, compliance, and support program for public-sector and government organizations.',
          'Content Lab means the AI-powered content creation and scheduling feature available on Enterprise plans that helps you generate, schedule, and publish content across multiple social media platforms.',
          'Social Media Management means the multi-platform social media management feature available on Enterprise plans that allows you to manage Facebook, LinkedIn, Instagram, X (Twitter), YouTube, and TikTok accounts from a single dashboard, including posting, messaging, commenting, and analytics.',
          'Moments means the multi-channel marketing automation feature that allows you to send WhatsApp Marketing, email campaigns, and bulk SMS messages from one unified dashboard. Moments includes WhatsApp Business API integration for template management, email campaign automation, and bulk SMS with sender ID registration.',
          'Push Notifications means the feature that enables businesses to send real-time browser and mobile push notifications to customers and users for engagement, updates, and promotional campaigns. Push Notifications includes web push for browsers and native push for iOS and Android applications.',
        ],
      },
      {
        title: '3. Accounts and Registration',
        paragraphs: [
          'To use most features, you must register. We support email and password registration and OAuth sign-in through Google, LinkedIn, and GitHub. You must provide accurate, current, and complete information.',
          'You are responsible for keeping your password and session token confidential and for all activity under your account. We recommend using a strong, unique password and enabling any security features we provide.',
          'We email a four-digit verification code that expires in five minutes. Password reset links and codes expire within one hour. Sessions are valid for up to 30 days.',
          'We may suspend or terminate accounts that violate these Terms, pose security risks, or provide false information.',
          'Business workspaces use role-based access: owner, admin, and agent. Owners control billing, seat purchases, and member invitations. You may only use the Service through the role and permissions assigned to you.',
        ],
      },
      {
        title: '4. Acceptable Use',
        paragraphs: [
          'You may use the Service only for lawful purposes and in accordance with these Terms.',
          'You agree not to use the Service to transmit illegal content, harass others, distribute malware, attempt unauthorized access, send spam, or violate the rights of any third party.',
          'You may not use AI Voice for unsolicited telemarketing, robocalling, spam, or any activity that violates telecom laws in your jurisdiction.',
          'You may not use Content Lab or Social Media Management to generate or publish content that is illegal, defamatory, hateful, harassing, or violates the rights of any third party. You are responsible for ensuring that your social media content complies with the terms of service and community guidelines of each platform (Facebook, LinkedIn, Instagram, X, YouTube, TikTok).',
          'You may not reverse engineer, scrape, interfere with, or overload the Service except as permitted by applicable law.',
          'You are responsible for ensuring that your use of Customer Data, including customer conversations, invoices, call recordings, and social media content, complies with applicable laws.',
        ],
      },
      {
        title: '5. Customer Data and Content',
        paragraphs: [
          'You retain ownership of all Customer Data, including messages, contacts, tickets, knowledge base articles, customer invoices, voice call recordings, workspace settings, Content Lab-generated content, and Social Media Management data.',
          'By using the Service, you grant us a limited license to host, process, transmit, and back up this data solely to provide, support, and improve the Service, and to keep logs required for security and audit purposes.',
          'You are responsible for the accuracy, quality, and legality of Customer Data and for obtaining any consents required to process it. This includes ensuring that content published through Content Lab and Social Media Management complies with applicable laws and platform policies.',
          'We do not use your Customer Data to train general AI models or for advertising without your consent. AI-assisted features process data for your own workspace and do not train shared models. Content Lab uses AI to generate content suggestions, but does not train shared models from your content.',
          'Activity logs are generated when users act inside a workspace. These logs include the action, timestamp, IP address, and user agent, and are stored to support audit, security, and debugging.',
          'Workspace owners may grant temporary access to ZuriHub staff for troubleshooting purposes. Temporary access grants are valid for 14 days and provide ZuriHub staff with access to the workspace to diagnose and resolve issues. Access grants can be revoked at any time by the workspace owner through workspace settings. ZuriHub staff are required to follow confidentiality and data protection obligations when granted temporary access.',
        ],
      },
      {
        title: '6. Visitor Analytics, Heatmaps, and Screen Recording',
        paragraphs: [
          'ZuriHub includes optional add-ons for live visitor tracking, heatmap replay, and remote screen recording. These features are disabled by default and must be turned on by a workspace owner or admin.',
          'When enabled, the visitor tracker collects page views, click and scroll coordinates, browser and device information, approximate location, and a snapshot of the page DOM for replay purposes. Screen recording allows an authorized agent to request a display capture from a website visitor, with the request processed through the visitor browser.',
          'You are responsible for complying with applicable laws, including obtaining any required visitor consent, providing appropriate cookie and privacy notices, and disclosing the use of these tracking technologies in your terms and privacy policy.',
          'You may not use these tools to record, track, or observe individuals in jurisdictions where such activity is prohibited without explicit consent, or to collect health, financial, or other sensitive personal data without legal authority.',
          'ZuriHub retains heatmap and visitor-event data for up to 30 days. Screen recordings are stored only if the upload completes through the standard upload flow and are subject to the same workspace data-retention settings.',
          'These features are billed separately from core agent seats as workspace add-ons when pricing is enabled. Pricing is published on the feature pages and may be adjusted with notice.',
        ],
      },
      {
        title: '7. AI Voice, Phone Numbers, and Voice Wallet',
        paragraphs: [
          'AI Voice is an optional add-on that lets you make, receive, transcribe, and analyze voice calls inside the ZuriHub inbox. Calls are routed through our CPaaS partners and are subject to their terms and acceptable use policies.',
          'Voice services are available in two modes: (1) with a dedicated phone number for traditional inbound/outbound calling, and (2) without a phone number for live chat widget and in-app agent calls. Both modes support AI transcription, recording, and smart routing.',
          'Dedicated Voice Numbers are available in Uganda, Kenya, Nigeria, Ethiopia, South Africa, Tanzania, Rwanda, and the United States. Numbers in African countries require a $25 one-time setup fee plus $25 monthly maintenance. USA numbers require a $25 setup fee with no monthly maintenance fee. Numbers remain active as long as fees are paid. We reserve the right to reclaim or reassign numbers that are inactive or unpaid.',
          'Live chat widget and in-app calls do not require a phone number and are priced at $0.005/minute (receive) and $0.007/minute (make). Traditional phone number calls are priced at $0.008/minute (receive) and $0.01/minute (make). All per-minute charges are deducted directly from your Voice Wallet. You must maintain a positive balance to make or receive calls.',
          'Premium add-ons include call recording at $0.005/minute and AI transcription at $0.004/minute. These are optional and can be enabled based on your needs.',
          'The following features are included free of charge: text-to-speech, conference calls, IVR menus with drag-and-drop builder and pre-built templates, and number masking for privacy protection.',
          'You are responsible for complying with all applicable telecom, recording, and privacy laws. You must obtain consent where required before recording calls. Recorded calls and transcripts are stored in your workspace and are part of your Customer Data.',
          'AI-generated call summaries, transcripts, and insights are produced for your workspace only. We do not use them to train shared AI models.',
          'We may suspend or restrict voice services for suspected fraud, spam, illegal use, or non-payment.',
        ],
      },
      {
        title: '7.1. IVR and Call Routing',
        paragraphs: [
          'The IVR (Interactive Voice Response) feature allows you to create custom call flows using a drag-and-drop builder with pre-built templates for common scenarios such as sales routing, support departments, after-hours handling, and multi-language support.',
          'You are responsible for configuring IVR menus in compliance with applicable laws, including providing appropriate disclosures about call recording, privacy practices, and data handling to callers.',
          'IVR configurations and call routing rules are stored as part of your Customer Data and are subject to the same security and retention policies as other workspace settings.',
          'Pre-built IVR templates are provided as a convenience and may be customized to fit your specific business requirements. You remain responsible for ensuring that your IVR configuration complies with all applicable regulations.',
        ],
      },
      {
        title: '8. Content Lab and Social Media Management',
        paragraphs: [
          'Content Lab is an Enterprise feature that uses AI to help you generate, schedule, and publish content across multiple social media platforms. Social Media Management allows you to manage Facebook, LinkedIn, Instagram, X (Twitter), YouTube, TikTok, and Pinterest accounts from a single dashboard.',
          'You are responsible for all content you create, schedule, or publish through Content Lab and Social Media Management. This includes ensuring compliance with the terms of service, community guidelines, and content policies of each social media platform.',
          'You may not use Content Lab or Social Media Management to publish content that is illegal, defamatory, hateful, harassing, violates intellectual property rights, or infringes on the rights of any third party.',
          'You are responsible for obtaining any necessary permissions, licenses, or consents for content you publish, including for images, videos, music, or third-party materials.',
          'AI-generated content suggestions are provided as a convenience. You are responsible for reviewing and approving all content before publication. We are not liable for content you publish, even if it was generated using AI suggestions.',
          'Social media account credentials and access tokens are stored securely in your workspace. You grant us permission to access your social media accounts solely to perform the actions you initiate through the Service, such as posting, scheduling, and responding to messages.',
          'For TikTok integration, we request the following scopes: user.info.basic (to read profile info including open ID, avatar, display name), video.publish (to directly post content to a user\'s TikTok profile), and video.upload (to share content as a draft for further editing and posting). These scopes are necessary for the functionality provided and are used only in accordance with TikTok\'s terms of service.',
          'You may revoke social media access at any time through your workspace settings. Upon revocation, we will no longer be able to perform actions on your behalf through the connected accounts.',
          'Content Lab and Social Media Management are available only on Enterprise plans and are subject to the Enterprise terms and pricing.',
        ],
      },
      {
        title: '8.1. ZuriChat Business Verification',
        paragraphs: [
          'ZuriChat Business is a messaging channel that allows businesses to register their phone numbers and receive messages from ZuriChat mobile app users. Businesses can obtain a blue badge verification status to build trust with customers.',
          'Blue badge verification requires a one-time payment of $99. This payment is non-refundable once verification is successfully completed and the blue badge is granted. The blue badge verification is permanent and does not require annual renewal fees.',
          'If verification cannot be completed due to technical issues, inability to verify phone number ownership, or other reasons beyond your control, you may request a refund within 14 days of payment. Refund requests must be submitted through the Book a Demo page or by contacting support.',
          'To register a ZuriChat business number, you must provide complete profile information including business name, business logo, username, and full name (for KYC verification). The business name appears as the primary display name to customers, while the full name is used for verification purposes only.',
          'Each workspace may have only one ZuriChat business number to maintain consistency and prevent customer confusion. If you need multiple business numbers for different business entities, you may create separate workspaces for each one.',
          'Business numbers cannot be registered if the same phone number is already registered in the ZuriChat consumer app. This prevents conflicts and ensures clean separation between personal and business use.',
          'ZuriChat business numbers are available worldwide with global OTP delivery. Businesses can register numbers from any country where they receive SMS messages.',
          'Businesses can only respond to customer-initiated conversations. Businesses cannot initiate outbound conversations to customers. This policy is similar to WhatsApp Business messaging rules and is designed to prevent spam and ensure customers control when they want to interact with businesses.',
          'Verified businesses may remove their business number after a 30-day waiting period from the date of approval or linking. This cooling-off period is to prevent abuse and ensure stable business-customer relationships.',
          'All ZuriChat business conversations are bridged to your unified inbox where they can be managed alongside other channels. Messages are end-to-end encrypted and subject to the same security and privacy policies as other customer communications.',
        ],
      },
      {
        title: '9. Moments: WhatsApp, Email, and SMS Marketing',
        paragraphs: [
          'Moments is a multi-channel marketing automation feature that allows you to send WhatsApp Marketing, email campaigns, and bulk SMS messages from one unified dashboard. Moments includes WhatsApp Business API integration for template management, email campaign automation, and bulk SMS with sender ID registration.',
          'WhatsApp Marketing use the Meta WhatsApp Business API and require template approval by Meta. You are responsible for ensuring that your WhatsApp templates comply with Meta Business Policy and applicable laws, including obtaining opt-in consent where required. Templates are categorized as Marketing, Utility, or Authentication and must follow Meta formatting guidelines.',
          'Email campaigns allow you to send newsletters, promotional emails, and automated sequences. You are responsible for ensuring email compliance, including CAN-SPAM, GDPR, and other applicable email marketing laws. This includes providing clear opt-out mechanisms, honoring unsubscribe requests, and obtaining consent where required.',
          'Bulk SMS messages require sender ID registration for professional delivery. You are responsible for ensuring SMS compliance, including obtaining opt-in consent where required, honoring opt-out requests, and complying with telecom regulations in each jurisdiction where you send messages.',
          'SMS Usage Guidelines: You may only send SMS messages to recipients who have given explicit consent to receive SMS communications from your business. Consent must be obtained through a clear opt-in mechanism such as a checkbox on a web form, written consent, or verbal consent recorded in your system. You must maintain records of consent for each recipient.',
          'SMS Content Requirements: SMS messages must not contain illegal, defamatory, hateful, harassing, or fraudulent content. Messages must accurately identify your business as the sender and include a clear opt-out mechanism (e.g., "Reply STOP to opt-out"). You must honor opt-out requests within 10 business days.',
          'SMS Pricing and Costs: Bulk SMS uses a pay-as-you-go pricing model based on published rates per message. The base rate is $0.008 USD per SMS (or equivalent in local currency). Volume discounts are automatically applied: 10% discount for 10,000+ messages, 15% discount for 50,000+ messages, and 20% discount for 100,000+ messages. SMS costs are deducted from your wallet balance in real-time. Prepaid SMS balances are non-refundable except where required by law.',
          'SMS Delivery and SLA: We strive to provide a 98% delivery rate for bulk SMS messages. Delivery times vary by destination country and carrier network but typically range from 5 seconds to 2 minutes. We provide delivery receipts and status tracking for each message. While we make reasonable efforts to ensure delivery, we cannot guarantee 100% delivery due to factors outside our control such as carrier network issues, recipient phone status, or incorrect phone numbers.',
          'SMS Sender ID Registration: You may register custom sender IDs (business names or brand names) for SMS delivery. Sender ID registration requires approval and may require documentation to prove business ownership. Some countries restrict or prohibit alphanumeric sender IDs; in such cases, numeric sender IDs will be used. You are responsible for ensuring your sender ID complies with local telecom regulations.',
          'SMS Contact Management and Personas: You can organize SMS recipients using workspace personas. Personas allow you to group contacts by attributes such as industry, location, or customer segment for targeted campaigns. You are responsible for ensuring that contact data stored in personas is accurate, up-to-date, and obtained with proper consent. Contact data includes phone numbers, names, and any custom variables used for personalization.',
          'SMS Personalization: You may use template variables such as {{name}}, {{order_id}}, and {{date}} to personalize SMS messages. Personalization data is drawn from your contact lists or persona groups. You are responsible for ensuring that personalization data is accurate and that recipients have consented to receive personalized messages.',
          'SMS Community Guidelines: You must accept and comply with SMS community guidelines before sending campaigns. These guidelines include prohibitions on spam, harassment, fraudulent content, and unsolicited marketing. We reserve the right to suspend SMS sending privileges for violations of these guidelines.',
          'SMS Drafts and Scheduling: You may save SMS campaign drafts and schedule messages for future delivery. Scheduled messages are sent automatically at the configured time. You are responsible for ensuring that scheduled content remains accurate and compliant at the time of sending. Recurring SMS schedules can be configured for daily, weekly, or monthly automated sending.',
          'SMS Templates: We provide 100+ professional SMS templates across 12 industries including retail, healthcare, education, finance, and more. Templates are optimized for 160-character limits and include variable placeholders for personalization. You may customize templates or create your own custom templates. You are responsible for ensuring that template content complies with applicable laws and regulations.',
          'SMS Analytics and Reporting: We provide real-time analytics for SMS campaigns including delivery rates, open rates (where supported by carrier), click rates, cost analysis, and engagement metrics. Campaign data is stored in your workspace and is part of your Customer Data. You can export analytics reports for your records.',
          'Third-party SMS Services: SMS messages are delivered through SMS gateway providers including Infobip and other regional carriers. Your use of SMS services is subject to the terms and privacy policies of these providers. We share only the data necessary for message delivery: recipient phone numbers, message content, sender ID, and delivery status.',
          'SMS Compliance: You are responsible for complying with all applicable SMS marketing laws including the Telephone Consumer Protection Act (TCPA) in the United States, GDPR in the European Union, and similar regulations in other jurisdictions. This includes maintaining proper consent records, honoring opt-out requests, and providing clear identification of your business in messages.',
          'Moments uses a pay-as-you-go pricing model across all channels. You pay only for the messages you send based on published rates for WhatsApp, email, and SMS. Volume discounts are available for high-volume senders. Prepaid balances are non-refundable except where required by law.',
          'You are responsible for the accuracy, quality, and legality of marketing content you send through Moments. This includes ensuring that promotional content, offers, and calls-to-action comply with applicable advertising and consumer protection laws.',
          'We provide delivery tracking, open rates, click rates, and engagement analytics for campaigns sent through Moments. This data is stored in your workspace and is part of your Customer Data.',
        ],
      },
      {
        title: '11. Fees, Billing, Cancellation, and Invoices',
        paragraphs: [
          'Some features require payment. Business workspace subscriptions are billed per agent seat on a monthly or annual basis. Add-ons such as Heatmaps, Screen Recording, and AI Voice Numbers are billed separately.',
          'AI Voice usage is deducted from the Voice Wallet in real time. Voice Wallet top-ups are non-refundable except where required by law.',
          'A 14-day free trial is available for new workspaces without a credit card. The trial may be extended once by seven days at the owner request. After the trial ends, payment is required to continue.',
          'Pricing is quoted in the selected currency and may include taxes and discounts. Payments are processed by Stripe, Flutterwave, or Airwallex depending on your region. We do not store full payment card numbers; these payment processors collect and process that information under their own terms.',
          'You may upgrade or add seats at any time. Additional seats are billed through the payment flow. Seat reductions take effect at the end of the current billing cycle.',
          'You may cancel through your workspace settings. Cancellation takes effect at the end of the current billing period, and the workspace may then move to a suspended or expired state.',
          'If payment is not received by the due date, the workspace becomes overdue. Overdue workspaces may be suspended after a 14-day grace period and may eventually be deleted. We do not refund fees except where required by law.',
          'The Service includes an invoice generator for your customers. You are responsible for the accuracy of customer invoices you create and send. We store invoice records on your behalf but are not responsible for payment collection between you and your customers.',
        ],
      },
      {
        title: '12. Intellectual Property',
        paragraphs: [
          'ZuriHub and all related code, designs, trademarks, logos, and content are the intellectual property of Zurichat Technology Company Limited or its licensors.',
          'You may not copy, modify, distribute, or create derivative works of our intellectual property except as expressly authorized.',
          'Feedback you provide may be used by us without restriction or compensation.',
        ],
      },
      {
        title: '13. Confidentiality and Security',
        paragraphs: [
          'We treat Customer Data as confidential and use reasonable technical and organizational measures to protect it.',
          'You are responsible for securing your account, using strong passwords, and ensuring your team follows best practices.',
        ],
      },
      {
        title: '14. Third-Party Integrations',
        paragraphs: [
          'The Service integrates with third parties such as Google, LinkedIn, and GitHub for OAuth authentication, Stripe, Flutterwave, and Airwallex for payment processing (region-dependent), Infobip for email delivery, WhatsApp for messaging, and CPaaS providers for voice calls.',
          'Your use of these services is subject to the third party own terms and privacy policies. We are not responsible for their availability, accuracy, security, or practices.',
          'We only share the data necessary to enable each integration.',
        ],
      },
      {
        title: '15. Limitation of Liability',
        paragraphs: [
          'To the fullest extent permitted by law, Zurichat Technology Company Limited will not be liable for any indirect, incidental, special, consequential, or punitive damages, including lost profits or data, arising from your use of the Service.',
          'Our total liability will not exceed the amount you paid to us in the twelve months before the event giving rise to the claim, or one hundred dollars, whichever is greater.',
        ],
      },
      {
        title: '16. Indemnification',
        paragraphs: [
          'You agree to indemnify and hold harmless ZuriHub, its affiliates, officers, and employees from any claims, damages, or expenses arising from your use of the Service, your Customer Data, or your violation of these Terms.',
        ],
      },
      {
        title: '17. Termination',
        paragraphs: [
          'We may suspend or terminate your access if you breach these Terms, fail to pay applicable fees, or if required by law. Suspended workspaces cannot be accessed until payment is made or the issue is resolved.',
          'You may cancel your subscription or delete your account at any time.',
          'When you request account deletion, we schedule redaction after a 30-day grace period. During this period the account is deactivated. At the end of the grace period we anonymize personal data such as name, email, phone, avatar, and password, and cancel active subscriptions. Billing and transaction records may be retained for legal and financial record-keeping.',
          'Upon termination, your right to use the Service ceases and we may delete or anonymize Customer Data in accordance with our Privacy Policy and applicable law.',
        ],
      },
      {
        title: '18. Governing Law and Disputes',
        paragraphs: [
          'These Terms are governed by the laws of the Republic of Uganda, without regard to its conflict of laws provisions.',
          'Any dispute arising under these Terms will be resolved in the courts of Uganda, unless otherwise agreed in writing.',
        ],
      },
      {
        title: '19. Changes to These Terms',
        paragraphs: [
          'We may modify these Terms from time to time. We will notify you of material changes by email or through the Service.',
          'Continued use of the Service after changes take effect means you accept the revised Terms.',
        ],
      },
      {
        title: '20. Enterprise, Zyra Agent, and White Label',
        paragraphs: [
          'Enterprise plans include additional governance, security, and AI features. These are governed by the same Terms, and by the specific feature terms below. Enterprise features include but are not limited to SSO, SCIM, custom SLAs, audit logs, private cloud or dedicated instance options, AI voice, Zyra Agent, and white-label branding.',
          'Zyra Agent is an Enterprise AI assistant available to qualified Enterprise workspaces. Zyra processes workspace conversations to provide reply suggestions, summaries, sentiment detection, intent routing, and autonomous ticket resolution. Zyra does not train shared or general AI models from your Customer Data. You may configure Zyra tone, allowed topics, and escalation rules from the workspace settings.',
          'White Label is available on Enterprise workspaces. It lets you replace ZuriHub branding in the workspace sidebar and customer-facing widgets with your own logo, colors, and, where supported, custom domain. You are responsible for ensuring that your white-labeled assets do not infringe any third-party rights.',
          'Dedicated instances and private cloud deployments are available under a separately executed Enterprise agreement. These deployments include data residency, single-tenant isolation, and advanced uptime commitments as agreed in writing.',
          'Enterprise pricing is custom and quoted based on agent count, feature selection, and deployment model. All Enterprise subscriptions require written acceptance of the applicable order or enterprise agreement.',
        ],
      },
      {
        title: '21. Contact Us',
        paragraphs: [
          'For questions about these Terms, please contact us at support@getzurihub.com or through the Book a Demo page.',
        ],
      },
    ],
  },
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: '25th September 2026',
    sections: [
      {
        title: '1. Overview',
        paragraphs: [
          'This Privacy Policy explains how Zurichat Technology Company Limited collects, uses, stores, shares, and protects your information when you use the ZuriHub website and services.',
          'We are committed to protecting your privacy and being transparent about our practices. This policy is written in plain language so you can understand what data we collect, why we collect it, and how we use it.',
          'If you have any questions after reading this policy, contact us at support@getzurihub.com.',
        ],
      },
      {
        title: '2. Who We Are',
        paragraphs: [
          'Zurichat Technology Company Limited, operating as ZuriHub, is the data controller for the information described in this policy.',
          'We are registered in the Republic of Uganda and provide customer experience and support software to teams around the world.',
        ],
      },
      {
        title: '3. Information We Collect and Why',
        paragraphs: [
          'Account and profile information: name, email, phone number, username, display name, avatar, company or workspace name, billing email, industry, company size, and website. We collect this to create and manage your account, communicate with you, and customize your workspace.',
          'Authentication and device data: password hash, OAuth provider (Google, LinkedIn, or GitHub) and identifier, session tokens, IP address, browser user agent, and timestamps. We collect this to keep your account secure, verify your identity, and prevent unauthorized access.',
          'Activity logs: action type, resource, metadata, IP address, and user agent. We collect this to detect suspicious activity, support audits, debug issues, and maintain a record of who did what in your workspace.',
          'Customer Data: messages, conversations, contacts, tickets, knowledge base articles, departments, business hours, widget settings, customer invoices, voice call recordings, transcripts, Content Lab-generated content, Social Media Management data, and any content you or your team submit. We collect and process this because you choose to store it in your workspace so we can deliver the Service.',
          'Voice and call data: call audio, transcripts, call metadata, Voice Number details, Voice Wallet balance, IVR configurations, and call routing rules. We collect this to provide AI Voice, call routing, transcription, recording, billing, and analytics.',
          'Website visitor data: page views, click and scroll events, browser and device data, approximate location, and DOM snapshots. We collect this when the Heatmaps, Live Analytics, or Screen Recording add-ons are enabled on a customer website.',
          'Social media data: social media account credentials (access tokens), connected account details, scheduled posts, published content, message history, comments, engagement metrics, and content drafts. We collect this to provide Content Lab and Social Media Management features on Enterprise plans.',
          'Moments marketing data: WhatsApp template configurations, email campaign content and recipient lists, SMS sender ID registrations, SMS recipient phone numbers and persona data (including names, custom variables, and segmentation attributes), SMS campaign content, SMS delivery receipts and status updates, SMS usage and cost data, SMS draft and schedule data, SMS template content and usage analytics, SMS community guidelines acceptance status, and campaign analytics (delivery rates, open rates, click rates). We collect this to provide WhatsApp Marketing, email campaigns, and bulk SMS features.',
          'Push Notifications data: user consent status, device tokens, browser and device identifiers, notification delivery status, click events, and campaign analytics. We collect this to provide browser and mobile push notifications for engagement, updates, and promotional campaigns.',
          'Billing and payment data: billing email, plan, seat count, currency, transaction reference, amount, status, and payment timestamp. We collect this to process payments and generate invoices. Card details are processed by Stripe, Flutterwave, or Airwallex depending on your region; we do not store full card numbers.',
          'Cookies and similar technologies: information about your device, browser, and site usage. We collect this to remember your preferences, understand how the site is used, and improve the user experience. See our Cookie Policy for more.',
        ],
      },
      {
        title: '4. How We Use Your Information',
        paragraphs: [
          'Provide and operate the Service, including workspaces, messaging, tickets, voice calls, analytics, Content Lab, Social Media Management, and Moments marketing automation.',
          'Authenticate you and keep your account secure.',
          'Process payments, subscriptions, Voice Wallet top-ups, Moments prepaid balances, and generate invoices.',
          'Send account, billing, and security notifications.',
          'Provide customer support and respond to your questions.',
          'Detect and prevent fraud, abuse, and security incidents.',
          'Comply with legal obligations and enforce our agreements.',
          'Improve the product using aggregated, non-identifiable usage data.',
          'Customer Data is used only to deliver the workspace features you enable. We do not use your Customer Data to build general AI models or for advertising without your consent.',
          'Where AI-assisted features are available, they process your workspace data for your own use and do not train shared models. Content Lab uses AI to generate content suggestions, but does not train shared models from your content.',
          'Social media credentials and access tokens are used solely to perform actions you initiate through the Service, such as posting, scheduling, and responding to messages on connected social media accounts.',
          'Moments marketing data is used to send WhatsApp Marketing, email campaigns, and bulk SMS messages according to your configured campaigns. Campaign analytics are stored in your workspace for reporting and optimization.',
          'Push Notifications data is used to send browser and mobile push notifications according to your configured campaigns. Device tokens and consent status are used to deliver notifications. Notification delivery and engagement analytics are stored in your workspace for reporting and optimization.',
        ],
      },
      {
        title: '5. Legal Bases for Processing',
        paragraphs: [
          'We process your information based on one or more of the following legal grounds:',
          'Performance of a contract: to provide the Service you signed up for.',
          'Consent: where you have given clear permission, such as for optional cookies or marketing communications.',
          'Legitimate interests: to keep the Service secure, to improve our product, and to support customers.',
          'Legal obligation: to comply with applicable laws, regulations, or court orders.',
        ],
      },
      {
        title: '6. Cookies and Similar Technologies',
        paragraphs: [
          'Our website uses cookies to remember your preferences, analyze traffic, and improve the user experience.',
          'Essential cookies are needed for the site to work. Functional cookies remember your settings. Analytics cookies help us understand how the site is used. Marketing cookies help us measure and improve our advertising.',
          'You can manage your cookie preferences through the Cookie Preferences panel linked in the footer.',
        ],
      },
      {
        title: '7. How We Share Information',
        paragraphs: [
          'We do not sell or rent your personal data.',
          'We share data with service providers who help us operate the Service. These include Cloudflare for hosting and database, Stripe, Flutterwave, and Airwallex for payment processing (region-dependent), Infobip for email delivery, Google, LinkedIn, and GitHub for OAuth, WhatsApp/Meta for messaging, CPaaS providers for voice calls, email delivery providers for email campaigns, SMS gateway providers for bulk SMS, push notification service providers for browser and mobile push notifications, and social media platforms (Facebook, LinkedIn, Instagram, X, YouTube, TikTok) for Content Lab and Social Media Management features. These providers are contractually bound to protect your data and use it only for the agreed purpose.',
          'We may disclose information if required by law, to protect our rights, safety, or property, to prevent fraud or abuse, or in connection with a business transfer such as a merger or acquisition.',
          'Customer invoices and related data are shared only with the workspace members and customers you choose to send them to.',
          'Social media content you publish through Content Lab and Social Media Management is shared publicly on the respective platforms according to your settings and the platform normal practices.',
          'WhatsApp templates and campaigns are shared with Meta for template approval and message delivery according to Meta Business API terms.',
          'Email campaigns are shared with email delivery providers for message transmission according to their terms and privacy policies.',
          'Bulk SMS messages and related data are shared with SMS gateway providers (including Infobip and regional carriers) for message delivery. We share recipient phone numbers, message content, sender ID, and delivery status. We do not share persona data, consent records, or analytics with third parties except as required for message delivery. Your use of SMS services is subject to the terms and privacy policies of these providers.',
        ],
      },
      {
        title: '11. Push Notifications',
        paragraphs: [
          'Push Notifications is a feature that enables businesses to send real-time browser and mobile push notifications to customers and users for engagement, updates, and promotional campaigns. Push Notifications includes web push for browsers and native push for iOS and Android applications.',
          'Browser push notifications require user consent through the browser native permission prompt. When a user grants permission, we store a device token that allows us to send notifications even when the user is not actively on your website. Users can revoke permission at any time through their browser settings.',
          'Mobile push notifications require a native mobile application. When users install and open your app, they are prompted to allow push notifications. Device tokens are stored and used to send notifications. Users can disable notifications through their device settings.',
          'Push notification campaigns can be segmented by user behavior, location, device type, or custom attributes. We process segmentation criteria, notification content, delivery status, click events, and engagement analytics. You are responsible for ensuring compliance with applicable laws, including obtaining opt-in consent where required.',
          'Push Notifications uses browser and platform native push services (such as Firebase Cloud Messaging, Apple Push Notification Service, and Web Push Protocol) to deliver notifications. Delivery, click, and engagement analytics are stored in your workspace for reporting and optimization.',
          'You can configure notification content, timing, and targeting from your workspace settings. Notification content may include headlines, body text, images, deep links, and custom data. Deep links can direct users to specific pages in your website or app.',
          'Push notification engagement metrics including delivery rates, open rates, click rates, and time-to-engagement are tracked and available in your workspace analytics. This data helps you optimize campaigns and improve user engagement.',
        ],
      },
      {
        title: '12. Voice, AI, and Website Analytics',
        paragraphs: [
          'If a workspace enables AI Voice, we process call audio, transcripts, call metadata, Voice Wallet transactions, IVR configurations, and call routing rules through our CPaaS partners. AI-generated transcripts and summaries are created for your workspace only and are not used to train shared models.',
          'Voice services operate in two modes: (1) traditional phone number calling with dedicated numbers, and (2) live chat widget and in-app calling without phone numbers. Both modes support AI transcription, recording, and smart routing. The data collected depends on the mode enabled and features selected.',
          'Call recording and transcription are optional add-ons. When enabled, call audio is recorded and transcribed using AI. Recordings and transcripts are stored in your workspace and are part of your Customer Data. You are responsible for obtaining consent where required before recording calls.',
          'IVR (Interactive Voice Response) configurations and call routing rules are stored as part of your Customer Data. These include menu structures, voice prompts, routing logic, and pre-built template customizations. IVR data is used to route calls according to your configured rules.',
          'Number masking is a privacy feature that anonymizes phone numbers in voice calls. When enabled, the actual phone numbers are replaced with masked identifiers in call logs and recordings to protect personal contact information.',
          'Voice call recordings and transcripts are retained according to the workspace owner settings. Call metadata and billing logs are retained for legal and financial record-keeping. You can configure retention periods in your workspace settings.',
          'If a workspace enables Live Visitors or Heatmaps, the ZuriHub tracker embedded on the customer website collects page views, click and scroll events, browser and device data, approximate location, and a snapshot of the page DOM. This data is used to display live visitor counts, replay sessions, and generate heatmaps.',
          'Visitor event and heatmap data is retained for up to 30 days and is automatically deleted after that period. The workspace can disable tracking at any time, and visitors can be informed through the customer own cookie or privacy notice.',
          'If Screen Recording is enabled, an authorized agent may request a display capture from the visitor browser. The recording is only created when the visitor explicitly consents through the browser native getDisplayMedia prompt. Recordings are processed and stored under the workspace account and are subject to the same deletion and redaction timelines as other Customer Data.',
          'The tracker does not attempt to bypass consent, does not collect password or payment card fields, and is designed to be disabled by default. You are responsible for configuring and disclosing these features in compliance with applicable law.',
        ],
      },
      {
        title: '13. Moments: WhatsApp, Email, and SMS Marketing',
        paragraphs: [
          'Moments is a multi-channel marketing automation feature that allows you to send WhatsApp Marketing, email campaigns, and bulk SMS messages from one unified dashboard. Moments includes WhatsApp Business API integration for template management, email campaign automation, and bulk SMS with sender ID registration.',
          'WhatsApp Marketing use the Meta WhatsApp Business API and require template approval by Meta. We process template submissions, campaign configurations, recipient lists, delivery receipts, and engagement analytics. You are responsible for ensuring that your WhatsApp templates comply with Meta Business Policy and applicable laws, including obtaining opt-in consent where required.',
          'Email campaigns allow you to send newsletters, promotional emails, and automated sequences. We process email content, recipient lists, delivery receipts, open rates, click rates, and engagement analytics. You are responsible for ensuring email compliance, including CAN-SPAM, GDPR, and other applicable email marketing laws.',
          'Bulk SMS messages require sender ID registration for professional delivery. We process SMS content, recipient lists, delivery receipts, and sender ID registration data. You are responsible for ensuring SMS compliance, including obtaining opt-in consent where required and complying with telecom regulations.',
          'SMS Contact Data: When you use bulk SMS, we process recipient phone numbers, names, and custom variables stored in your workspace personas. Persona data includes contact attributes such as industry, location, customer segment, and any custom fields you define. This data is used for message personalization (e.g., {{name}}, {{order_id}}) and audience segmentation.',
          'SMS Consent Records: You are responsible for maintaining records of SMS opt-in consent for each recipient. While we do not store consent records on your behalf, the SMS platform requires that you only send messages to recipients who have given explicit consent. Consent may be obtained through web forms, written agreements, or verbal consent recorded in your systems.',
          'SMS Delivery Data: We collect and store SMS delivery receipts, status updates (sent, delivered, failed, pending), and delivery timestamps. This data is used to provide delivery tracking, analytics, and reporting. Delivery data is retained according to your workspace data retention settings.',
          'SMS Sender ID Data: We process sender ID registration information including your business name, registration documents, and approval status. Sender ID data is stored to ensure compliance with telecom regulations and to enable message delivery with your branded sender ID.',
          'SMS Cost and Billing Data: We process SMS usage data including message count, recipient count, volume discount calculations, and costs per message. This data is used to calculate charges, apply volume discounts, and deduct from your wallet balance. Billing records are retained for financial and legal record-keeping.',
          'SMS Template Data: We store SMS template content, industry categories, character counts, and variable placeholders. Template data is stored in your workspace and can be customized for your brand. Template usage analytics including which templates are used most frequently are tracked and stored.',
          'SMS Campaign Analytics: We collect and store campaign performance metrics including delivery rates, open rates (where supported by carriers), click rates, cost analysis, and engagement data. Analytics data is used for reporting, optimization, and ROI calculation. Campaign analytics are retained according to your workspace settings.',
          'SMS Draft and Schedule Data: We store SMS campaign drafts including message content, recipient lists, scheduling dates, and recurrence settings. Draft data is retained until you delete it or send the campaign. Scheduled campaign data is retained until the scheduled send time and converted to campaign data after sending.',
          'SMS Community Guidelines: We track your acceptance of SMS community guidelines. Guidelines acceptance status is stored per workspace and must be acknowledged before sending SMS campaigns. We may suspend SMS sending privileges for violations of community guidelines including spam, harassment, or fraudulent content.',
          'SMS Third-Party Sharing: SMS messages are delivered through SMS gateway providers including Infobip and regional carriers. We share recipient phone numbers, message content, sender ID, and delivery status with these providers solely for message delivery. We do not share persona data, consent records, or analytics with third parties except as required for message delivery.',
          'SMS Data Retention: SMS campaign data, delivery receipts, and analytics are retained according to your workspace data retention settings. Recipient phone numbers and persona data are retained as long as your workspace is active or until you delete the data. Upon workspace deletion, SMS data may be anonymized or deleted subject to legal retention requirements.',
          'Moments uses a pay-as-you-go pricing model. You pay only for the messages you send based on published rates for WhatsApp, email, and SMS. Prepaid balances are non-refundable except where required by law.',
          'Campaign analytics including delivery rates, open rates, click rates, and engagement metrics are stored in your workspace for reporting and optimization.',
          'Third-party services used for Moments include Meta for WhatsApp Business API, email delivery providers for email campaigns, and SMS gateway providers for bulk SMS. Your use of these services is subject to their respective terms and privacy policies.',
        ],
      },
      {
        title: '14. Content Lab and Social Media Management',
        paragraphs: [
          'Content Lab and Social Media Management are Enterprise features that allow you to manage social media accounts on Facebook, LinkedIn, Instagram, X (Twitter), YouTube, and TikTok from a single dashboard. Content Lab also provides AI-powered content generation suggestions.',
          'When you connect a social media account, we store access tokens and account metadata in your workspace. These credentials are used solely to perform actions you initiate, such as posting, scheduling content, responding to messages, and retrieving analytics.',
          'For TikTok integration, we request the following scopes when you connect your account: user.info.basic (to read profile info including open ID, avatar, display name), video.publish (to directly post content to your TikTok profile), and video.upload (to share content as a draft for further editing and posting). These scopes are necessary for the functionality provided and are used only in accordance with TikTok\'s terms of service.',
          'You can revoke social media access at any time through your workspace settings. Upon revocation, we delete the access tokens and can no longer perform actions on your behalf through the connected accounts.',
          'Content Lab uses AI to generate content suggestions based on your inputs and preferences. The AI processes your prompts and generates suggestions for your workspace only. We do not use your content or prompts to train shared or general-purpose AI models.',
          'Content you create, schedule, or publish through Content Lab and Social Media Management is stored in your workspace as part of your Customer Data. Published content becomes publicly visible on the respective social media platforms according to your settings and the platform normal practices.',
          'You are responsible for ensuring that all content you publish complies with applicable laws and the terms of service of each social media platform. We are not liable for content you publish, even if it was generated using AI suggestions.',
          'Social media engagement data (likes, comments, shares, views) and analytics retrieved from connected platforms are stored in your workspace and used to provide performance insights.',
          'Draft content, scheduled posts, and publishing history are retained according to your workspace data retention settings. You can delete drafts and scheduled posts at any time.',
        ],
      },
      {
        title: '11. How Long We Keep Your Information',
        paragraphs: [
          'We keep your personal information and Customer Data for as long as your account or workspace is active or as needed to provide the Service.',
          'Sessions are active for up to 30 days. Email verification codes expire after five minutes. Password reset tokens expire after one hour.',
          'Voice call recordings and transcripts are retained according to the workspace owner settings, with options ranging from 24 hours to extended retention periods for Enterprise customers. Call metadata, IVR configurations, and billing logs are retained for legal and financial record-keeping.',
          'Voice Wallet transaction records and call billing logs are retained for financial record-keeping and audit purposes, even after account deletion, as required by applicable law.',
          'SMS campaign data, delivery receipts, and analytics are retained according to your workspace data retention settings. SMS recipient phone numbers and persona data (including names, custom variables, and segmentation attributes) are retained as long as your workspace is active or until you delete the data. SMS sender ID registration data is retained as long as the sender ID remains active.',
          'SMS draft and schedule data is retained until you delete the draft or send the scheduled campaign. SMS template data is retained as long as your workspace is active or until you delete the templates.',
          'SMS usage and cost data including message counts, volume discount calculations, and billing records are retained for financial and legal record-keeping, even after account deletion.',
          'If you request account deletion, we schedule redaction after a 30-day grace period. During that period the account is deactivated. At the end of the period we anonymize personal data by clearing or replacing fields such as display name, username, email, phone, bio, avatar, password hash, and OAuth identifiers.',
          'Billing, subscription, and transaction records are retained for legal and financial record-keeping.',
          'Customer Data in a workspace is retained according to the workspace owner settings. When a workspace is closed or deleted, we may remove or anonymize associated data, subject to legal retention requirements.',
        ],
      },
      {
        title: '12. Data Security',
        paragraphs: [
          'We use appropriate technical and organizational security measures, including encryption in transit, access controls, regular security reviews, and staff training.',
          'Voice call recordings and transcripts are encrypted at rest and in transit. Voice Wallet transactions are secured through industry-standard payment processing protocols.',
          'IVR configurations and call routing rules are protected by the same access controls as other workspace settings. Only authorized workspace members can modify IVR menus and routing logic.',
          'No system is completely secure. We cannot guarantee absolute security, but we work hard to protect your data and respond quickly to any issues.',
        ],
      },
      {
        title: '13. International Transfers',
        paragraphs: [
          'Your data may be stored and processed in data centers located outside your country, including in Africa, Europe, North America, and Asia-Pacific.',
          'We take steps to ensure that international transfers are protected through appropriate safeguards, such as standard contractual clauses and data processing agreements.',
        ],
      },
      {
        title: '14. Your Rights',
        paragraphs: [
          'Depending on your location, you may have rights to access, correct, delete, restrict, or object to processing of your personal data, and to request portability or withdraw consent.',
          'To exercise your rights or ask questions, contact us at support@getzurihub.com. If your data is controlled by a business workspace, we may need to coordinate with the workspace owner or admin.',
          'We will respond within the timeframe required by applicable law.',
        ],
      },
      {
        title: '15. Children',
        paragraphs: [
          'ZuriHub is not intended for use by individuals under the age of 18, or the minimum legal age in your jurisdiction.',
          'We do not knowingly collect data from children. If you believe a child has provided us with personal data, contact us immediately.',
        ],
      },
      {
        title: '16. Changes to This Policy',
        paragraphs: [
          'We may update this Privacy Policy from time to time. We will post the revised version on this page and update the effective date.',
          'Significant changes will be communicated to you by email or through the Service.',
        ],
      },
      {
        title: '18. Enterprise, AI, Voice, and White Label Data',
        paragraphs: [
          'Enterprise workspaces may use additional features such as Zyra Agent, AI Voice, white-label branding, dedicated instances, private cloud, advanced audit logging, Content Lab, and Social Media Management. These features process Customer Data in the same secure, workspace-isolated way as the rest of the Service.',
          'Zyra Agent and other AI-assisted features process messages, tickets, and help-center content to generate replies, summaries, and routing suggestions. We do not use your Customer Data to train shared or general-purpose AI models. Each workspace retains control over its tone, escalation rules, and allowed topics.',
          'AI Voice features process call audio, transcripts, IVR configurations, and call routing rules. Voice call recordings and AI-generated transcripts are stored in your workspace and are not used to train shared AI models. Number masking protects personal phone numbers in call logs and recordings.',
          'Content Lab uses AI to generate content suggestions for social media posts. The AI processes your prompts and generates suggestions for your workspace only. We do not use your content or prompts to train shared or general-purpose AI models.',
          'Social Media Management stores social media access tokens, account metadata, scheduled posts, published content, message history, and engagement analytics. This data is stored in your workspace and is used solely to manage your connected social media accounts.',
          'White-label branding uses your uploaded logo, brand colors, custom domain, and display name. These assets are stored in your workspace and are only used to render the white-labeled experience for your team and customers.',
          'Dedicated and private cloud deployments keep Customer Data in isolated infrastructure or regions as agreed in the Enterprise order. Audit logs record user actions inside the workspace and are retained according to the Enterprise plan settings.',
        ],
      },
      {
        title: '18.1. ZuriChat Business Data',
        paragraphs: [
          'ZuriChat Business is a messaging channel that allows businesses to register their phone numbers and receive messages from ZuriChat mobile app users. Business profile information including business name, logo, username, and full name (for KYC verification) is stored in your workspace.',
          'Business phone numbers and OTP codes are stored securely in your workspace. OTP codes are used for verification and expire after 5 minutes. Once verified, the business receives a permanent blue badge status.',
          'All ZuriChat business conversations are bridged to your unified inbox and are subject to the same security, privacy, and retention policies as other customer communications. Messages are end-to-end encrypted and stored in your workspace.',
          'Business verification status and payment records are retained in your workspace. The one-time $99 verification payment is non-refundable once verification is successfully completed. Refunds are only available if verification cannot be completed due to technical issues.',
          'Business phone numbers are available worldwide with global OTP delivery. We do not restrict business numbers to specific countries, allowing businesses to register numbers from any country where they receive SMS messages.',
          'Each workspace may have only one ZuriChat business number. Business numbers cannot be registered if the same phone number is already registered in the ZuriChat consumer app to prevent conflicts.',
          'Verified businesses may remove their business number after a 30-day waiting period from the date of approval or linking. During this cooling-off period, the business number remains active.',
        ],
      },
      {
        title: '17. Contact Us',
        paragraphs: [
          'For privacy questions or data requests, contact us at support@getzurihub.com or through the Book a Demo page.',
        ],
      },
    ],
  },
  cookie: {
    title: 'Cookie Policy',
    lastUpdated: 'August 7, 2026',
    paragraphs: [
      'ZuriHub uses cookies and similar technologies to provide, secure, and improve our website and platform.',
      'Essential cookies are needed for the website to work and cannot be disabled. Without these cookies, you would not be able to log in, keep a session, or use core features.',
      'Functional cookies remember choices you make, such as language or region, so you do not have to enter them again.',
      'Analytics cookies help us understand how visitors move through the site, which pages are popular, and where we can improve.',
      'Marketing cookies help us measure the performance of our advertising and show relevant messages to people who may be interested in ZuriHub.',
      'You can manage your cookie preferences at any time by clicking the Cookie Preferences button in the footer of our website.',
      'By continuing to use our site without changing your settings, you consent to the use of cookies as described in this policy.',
      'For questions, contact us at support@getzurihub.com.',
    ],
  },
};
